import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ScrollToTopBtn from "./menu/ScrollToTop";
import Header from "./menu/header";
import Home from "./pages/home";
import useRegisterWallet from "../Common/useRegisterWallet.js"; // Adjust path
import CustomToastContainer from "../Common/CustomToastContainer.js";

import Home1 from "./pages/home1";
import Home2 from "./pages/home2";
import Explore from "./pages/explore";
import Explore2 from "./pages/explore2";
import Helpcenter from "./pages/helpcenter";
import ExploreOpensea from "./pages/Opensea/explore";
// import Rangking from './pages/rangking';
import RankingRedux from "./pages/RankingRedux";
import Colection from "./pages/colection";
import ItemDetail from "./pages/ItemDetail";
import ItemDetailRedux from "./pages/ItemDetailRedux";
import Author from "./pages/Author";
import AuthorOpensea from "./pages/Opensea/author";
import Wallet from "./pages/wallet";
import Login from "./pages/login";
import LoginTwo from "./pages/loginTwo";
import Register from "./pages/register";
import Price from "./pages/price";
import Works from "./pages/works";
import News from "./pages/news";
import NewsSingle from "./pages/newsSingle";
import Create from "./pages/create";
import EditNft from "./pages/EditNft";
import CreateBundle from "./pages/CreateBundle";
import GetCollection from "./pages/GetCollection.js";
import Createoption from "./pages/createOptions";
import Auction from "./pages/Auction";
import Activity from "./pages/activity";
import Contact from "./pages/contact";
import ElegantIcons from "./pages/elegantIcons";
import EtlineIcons from "./pages/etlineIcons";
import FontAwesomeIcons from "./pages/fontAwesomeIcons";
import Accordion from "./pages/accordion";
import Alerts from "./pages/alerts";
import Progressbar from "./pages/progressbar";
import Tabs from "./pages/tabs";
import Minter from "./pages/Minter";
import auth from "../core/auth";
import EditProfile from "../components/components/EditProfile.js";
import Profile from "../components/components/Profile.js";
import Blog from "../components/components/Blog.js";
import BlogSingle from "../components/components/BlogSingleDetails.js";
import Settings from "../components/components/SettingsPage.js";
import Exchange from "../components/components/Exchange.js";
import CreateNft from "./pages/Create/index.js";
import SingleNFt from "../components/components/SingleNFt.js";
import { createGlobalStyle } from "styled-components";
import DropPage from "./components/DropPage.js";
import AcceptBid from "../components/components/AcceptBid.js";
import SellerProfile from "../components/components/SellerProfile.js";
import ListNFTForSale from "../components/components/ListNFTForSale.js";
import CreateAuction from "./pages/createAuction.js";

const GlobalStyles = createGlobalStyle`
  :root {
    scroll-behavior: unset;
  }
`;

const ProtectedRoute = ({ children }) => {
  let location = useLocation();
  const isAuth = auth.getToken() !== null;

  return isAuth ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

const App = () => {
  const toastRef = useRef();

  useRegisterWallet(toastRef);

  return (
    <>
      <div className="wraper">
        <GlobalStyles />
        <Header />
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* <Route path="/Author">
            <Route
              path=":authorId"
              element={
                <ProtectedRoute>
                  <Author />
                </ProtectedRoute>
              }
            />
          </Route> */}
          {/* <Route path="/Profile">
        <Route
          path=":authorId"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Route> */}
          <Route path="/" element={<Home1 />} />
          <Route element={<Home1 />} path="/home1" />
          <Route element={<Home2 />} path="/home2" />
          <Route element={<Explore />} path="/explore/:category" />
          <Route element={<Explore2 />} path="/explore2" />
          <Route element={<ExploreOpensea />} path="/exploreOpensea" />
          <Route element={<RankingRedux />} path="/rangking" />
          <Route element={<Auction />} path="/Auction" />
          <Route element={<Helpcenter />} path="/helpcenter" />
          <Route element={<Colection />} path="/colection/:collectionId" />
          <Route element={<ItemDetailRedux />} path="/art/:nftId" />
          <Route element={<ItemDetail />} path="/ItemDetail" />
          <Route element={<AuthorOpensea />} path="/AuthorOpensea" />
          <Route element={<Author />} path="/author" />
          <Route element={<Wallet />} path="/wallet" />
          <Route element={<Login />} path="/login" />
          <Route element={<LoginTwo />} path="/loginTwo" />
          <Route element={<Register />} path="/register" />
          <Route element={<Price />} path="/price" />
          <Route element={<AcceptBid />} path="/accept-bid" />
          <Route element={<Profile />} path="/profile" />
          <Route element={<EditProfile />} path="/edit-profile" />
          <Route element={<Settings />} path="/settings" />
          <Route element={<Exchange />} path="/exchange" />
          <Route element={<DropPage />} path="/drop" />
          <Route element={<Works />} path="/works" />
          <Route element={<News />} path="/news" />
          <Route element={<SingleNFt />} path="/nft/:id" />
          <Route element={<NewsSingle />} path="/news/:postId" />
          <Route element={<Create />} path="/create" />
          <Route element={<CreateAuction />} path="/create-auction" />
          <Route element={<ListNFTForSale />} path="/list-nft-sale" />
          <Route element={<Blog />} path="/blog" />
          <Route element={<BlogSingle />} path="/blog/:id" />
          <Route element={<EditNft />} path="/edit-art/:nftId" />
          <Route element={<CreateBundle />} path="/create-collection" />
          <Route element={<GetCollection />} path="/collection/:collectionId" />
          <Route element={<Createoption />} path="/createOptions" />
          <Route element={<Activity />} path="/activity" />
          <Route element={<Contact />} path="/contact" />
          <Route element={<ElegantIcons />} path="/elegantIcons" />
          <Route element={<EtlineIcons />} path="/etlineIcons" />
          <Route element={<FontAwesomeIcons />} path="/fontAwesomeIcons" />
          <Route element={<Accordion />} path="/accordion" />
          <Route element={<Alerts />} path="/alerts" />
          <Route element={<Progressbar />} path="/progressbar" />
          <Route element={<Tabs />} path="/tabs" />
          <Route element={<Minter />} path="/mint" />
          <Route path="/seller/:userAddress" element={<SellerProfile />} />
          <Route element={<CreateNft />} path="/createNft" />
        </Routes>
        <ScrollToTopBtn />
      </div>
      <CustomToastContainer ref={toastRef} />
    </>
  );
};
export default App;
